import { WishlistDispatcher as SourceWishlistDispatcher } from 'SourceStore/Wishlist/Wishlist.dispatcher';
import WishlistQuery from 'Query/Wishlist.query';
import { fetchMutation } from 'Util/Request';
import { updateIsLoading } from 'Store/Wishlist/Wishlist.action';
import { showNotification } from 'Store/Notification/Notification.action';

const CartDispatcher = import(/* webpackMode: "lazy", webpackChunkName: "dispatchers" */'Store/Cart/Cart.dispatcher');

export class WishlistDispatcher extends SourceWishlistDispatcher {
    addItemToWishlist(dispatch, wishlistItem) {
        dispatch(updateIsLoading(true));

        return fetchMutation(WishlistQuery.getSaveWishlistItemMutation(wishlistItem)).then(
            () => {
                this._syncWishlistWithBE(dispatch)
                dispatch(showNotification('success', __('The product was added to Favorites')));
            },
            (error) => {
                dispatch(showNotification('error', __('Error updating wish list!')));
                // eslint-disable-next-line no-console
                console.log(error);
            }
        );
    }

    moveWishlistToCart(dispatch, sharingCode) {
        return fetchMutation(WishlistQuery.getMoveWishlistToCart(sharingCode))
            .then(() => {
                //dispatch(clearWishlist());
                CartDispatcher.then(({ default: dispatcher }) => dispatcher._syncCartWithBE(dispatch));
            });
    }
}

export default new WishlistDispatcher();
